import React from 'react';
import clsx from 'clsx';
import './button-link.css';

export default function ButtonLink(props) {
  const { inherit = false, type = 'button', className, children, onClick } = props;
  return (
    <button
      type={type}
      className={clsx('button-link', className, {
        ['button-link--inherit']: inherit,
      })}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
